import React from 'react';
import { teamMembers } from '../data/mockData';

const Team = () => {
  return (
    <div className="team-page">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">Our Team</h1>
          <p className="page-subtitle">
            Meet the skilled professionals who bring your luxury home dreams to life with expertise, creativity, and unwavering dedication to excellence.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="grid grid-3">
            {teamMembers.map(member => (
              <div key={member.id} className="team-card">
                <div className="team-image-container">
                  <img src={member.image} alt={member.name} className="team-image" />
                </div>
                <div className="team-info">
                  <h3 className="team-name">{member.name}</h3>
                  <div className="team-role">{member.role}</div>
                  <p className="team-bio">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* Expertise Section */}
      <section className="section expertise-section">
        <div className="container">
          <div className="grid grid-2">
            <div className="expertise-content">
              <h2 className="section-title" style={{ textAlign: 'left' }}>34+ Years of Expertise</h2>
              <p className="expertise-text">
              As a three-generation family business, we bring a mix of deep-rooted experience and fresh ideas to every project. Over the years, we've built more than 750 custom homes, each one crafted to match our clients’ unique lifestyle and vision.
              </p>
              <div className="expertise-stats">
                <div className="stat-item" style={{ margin: '0 auto' }}>
                  <div className="stat-number">750+</div>
                  <div className="stat-label">Completed Projects</div>
                </div>
               
              </div>
            </div>
            <div className="expertise-image">
              <img 
                src="https://photos.zillowstatic.com/fp/8d06ad7aac190f7af8bb74aadf686c76-uncropped_scaled_within_1536_1152.webp" 
                alt="Team collaboration" 
                className="expertise-img"
              />
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .team-page {
          padding-top: 80px;
        }

        .page-header {
          background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
          color: var(--white);
          padding: 80px 0;
          text-align: center;
        }

        .page-title {
          font-size: 3rem;
          margin-bottom: 20px;
          font-family: 'Playfair Display', serif;
        }

        .page-subtitle {
          font-size: 1.25rem;
          color: var(--light-blue);
          max-width: 700px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .team-card {
          background: var(--white);
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .team-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
        }

        .team-image-container {
          position: relative;
          overflow: hidden;
        }

        .team-image {
          width: 100%;
          height: 500px;
          object-fit: contain;
          background: #f5f5f5;
          transition: transform 0.3s ease;
        }

        /* Removed team overlay and hover effect */

        .team-social {
          display: flex;
          gap: 20px;
        }

        .social-link {
          color: var(--white);
          text-decoration: none;
          padding: 10px 20px;
          border: 2px solid var(--white);
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .social-link:hover {
          background: var(--white);
          color: var(--primary-blue);
        }

        .team-info {
          padding: 30px;
          text-align: center;
        }

        .team-name {
          font-size: 1.5rem;
          color: var(--primary-blue);
          margin-bottom: 8px;
          font-family: 'Playfair Display', serif;
        }

        .team-role {
          color: var(--gold-accent);
          font-weight: 600;
          margin-bottom: 15px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .team-bio {
          color: var(--text-light);
          line-height: 1.6;
        }

        .values-section {
          background: var(--off-white);
        }

        .value-card {
          background: var(--white);
          padding: 40px 30px;
          border-radius: 12px;
          text-align: center;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .value-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
        }

        .value-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }

        .value-title {
          font-size: 1.5rem;
          color: var(--primary-blue);
          margin-bottom: 15px;
          font-family: 'Playfair Display', serif;
        }

        .value-description {
          color: var(--text-light);
          line-height: 1.6;
        }

        .expertise-section {
          background: var(--white);
        }

        .expertise-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .expertise-text {
          font-size: 1.125rem;
          line-height: 1.7;
          color: var(--text-light);
          margin-bottom: 40px;
        }

        .expertise-stats {
          display: flex;
          justify-content: center;
          gap: 40px;
          margin-bottom: 40px;
        }

        .stat-item {
          text-align: center;
        }

        .stat-number {
          font-size: 2.5rem;
          font-weight: 700;
          color: var(--gold-accent);
          font-family: 'Playfair Display', serif;
          margin-bottom: 5px;
        }

        .stat-label {
          font-size: 0.875rem;
          color: var(--text-dark);
          font-weight: 600;
        }

        .expertise-certifications h4 {
          color: var(--primary-blue);
          margin-bottom: 15px;
          font-family: 'Playfair Display', serif;
        }

        .expertise-certifications ul {
          list-style: none;
          padding: 0;
        }

        .expertise-certifications li {
          padding: 8px 0;
          color: var(--text-light);
          position: relative;
          padding-left: 20px;
        }

        .expertise-certifications li::before {
          content: '✓';
          position: absolute;
          left: 0;
          color: var(--gold-accent);
          font-weight: 700;
        }

        .expertise-image {
          position: relative;
          overflow: hidden;
          border-radius: 12px;
        }

        .expertise-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .expertise-image:hover .expertise-img {
          transform: scale(1.05);
        }

        @media (max-width: 768px) {
          .page-title {
            font-size: 2rem;
          }

          .expertise-stats {
            flex-direction: column;
            gap: 20px;
            text-align: center;
          }

          .expertise-content {
            order: 2;
          }

          .expertise-image {
            order: 1;
            margin-bottom: 40px;
          }
        }
      `}</style>
    </div>
  );
};

export default Team;